import React from 'react';
import PropTypes from 'prop-types';

import { components } from 'react-select';

import { Icon } from '../../Elements';

import classes from './OptionPart.module.scss';

const OptionPart = props => {
  const { data, isSelected } = props;
  return (
    <components.Option {...props} className={classes.optionPart}>
      <p className={classes.optionPart}>
        {data.value}
        {isSelected && <Icon icon={'Icn_Chat'} className={classes.icon} />}
      </p>
    </components.Option>
  );
};

OptionPart.propTypes = {
  data: PropTypes.object,
  isSelected: PropTypes.bool
};

export default OptionPart;
